import React from "react";
import Marquee from "react-fast-marquee";
import { MARQUEE } from "../../data/content";

export const MarqueeStrip = () => (
  <div className="border-y border-border py-5 md:py-6 bg-background overflow-hidden" data-testid="marquee">
    <Marquee speed={40} gradient={false} autoFill>
      {MARQUEE.map((m, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display uppercase text-3xl md:text-5xl tracking-tight px-8 text-muted-foreground">
            {m}
          </span>
          <span className="text-[hsl(var(--accent))] text-2xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
